const bookingStatusCodes = {
    AVAILABLE: 0,
    ENQUIRED: 1,
    TAKEN: 2,
    RESERVED: 2,
    BLOCKED: 3,
    BOOKED: 4,
    UNAVAILABLE: 5,
    CANCELLED: 6,
    NOT_LIVE: 7,
    WAIT: 8,
    HELD: 9,
    QUEUE: 10,
    CREATED_EXTERNALLY: 11
};

export {
    bookingStatusCodes
}
